import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import { EightDayListView } from "./component/eightday_listview";

const {ccclass, property} = cc._decorator;

@ccclass
export class EightDayView extends ViewBase {

    @property(EightDayListView)
    mTaskList:EightDayListView = null;

    @property(EightDayListView)
    mDayList:EightDayListView = null;


    initView(){
        this.mTaskList.initListView(this.update_Task_list_item,this);
        this.mDayList.initListView(this.update_Day_list_item,this);
    }

    setTaskData(){
        this.mTaskList.setData([1,2,3,4,5,6]);
        this.mDayList.setData([1,2,3,4,5,6,7,8,1,2,2,2,9])
    }

    setDayData(){

    }

    protected update_Task_list_item(itemNode: cc.Node, data: any, index: number){
        cc.log('Task',itemNode,data,index);
    }

    protected update_Day_list_item(itemNode: cc.Node, data: any, index: number){
        let lab = cc.find('round',itemNode).getComponent(cc.Label);
        lab.string = index+'';
        cc.log('Day',itemNode,data,index);
    }
}
